<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'VTitleEditor',
  extends: compoment
}
</script>
